module.exports = __webpack_public_path__ + "static/media/RAHUL-PANDITA.8624dd98.png";